import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthorizationService } from 'src/app/core/services/authorization.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  signupForm: FormGroup;
  submitted = null;
  email: string;
  requested: boolean = false;
  mdlSampleIsOpen : boolean = false;
  contestEnvStartDate: Date = environment.contestStartDate;

  constructor(private formBuilder: FormBuilder, private authService: AuthorizationService) {
    this.createForm();
  }

  ngOnInit() {
    if(new Date() < this.contestEnvStartDate) this.mdlSampleIsOpen = true; // check for contest start, if not started block the screen
  }

  createForm() {
    this.signupForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.minLength(4), Validators.required]],
      // password: ['',[Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}'), Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = false;
    if (this.signupForm.invalid) {
      return;
    }

    this.submitted = true;
    if (this.signupForm.valid) {
        this.email = this.signupForm.value.email;
        this.authService.signup(this.signupForm.value)
          .pipe(first())
          .subscribe(res => {
            this.requested = true;
          });
        this.clearForm();
    }
  }

  get f() { return this.signupForm.controls }

  clearForm() {
    this.submitted = false;
    this.signupForm.reset();
    Object.keys(this.signupForm.controls).forEach(key => {
      this.signupForm.get(key).setErrors(null);
    });
  }
}
